import React from 'react';
import { Typography, theme } from 'antd';
import { HiDocumentText } from 'react-icons/hi';

const { Title } = Typography;

/**
 * Form Header Component - Displays form name
 */
export const FormHeader = ({ 
  formName, 
  schema, 
  showHeader = true,
  compact = false
}) => {
  const { token } = theme.useToken();
  
  if (!showHeader) return null;
  
  const displayName = formName || schema?.name || 'Form';
  
  return (
    <div style={{ 
      paddingBottom: compact ? 12 : 16,
      marginBottom: compact ? 12 : 16,
      borderBottom: compact ? 'none' : '1px solid #f0f0f0'
    }}>
      <div style={{ 
        display: 'flex', 
        alignItems: 'center', 
        gap: 12
      }}>
        <HiDocumentText style={{ fontSize: 24, color: token.colorPrimary }} />
        <Title level={4} style={{ margin: 0 }}>{displayName}</Title>
      </div>
    </div>
  );
};




